<template>
  <div class="m-l-10">
    <div v-for="option in options" class="m-t-10" :class="{'inlineCheckbox': !option.child}">
      <el-checkbox :label="option.id" @change="selectThis(option)">{{ option.name }}</el-checkbox>
      <template v-if="option.child">
        <checkbox-demo :index="index" v-model="childValue" :options="option.child" @input="change" @isAll="isAll"></checkbox-demo>
      </template>
    </div>
  </div>
</template>
<style scoped>
  .inlineCheckbox{
    display: inline-block !important;
    margin-right: 20px;
  }
</style>
<script>
  import checkboxDemo from './checkboxDemo'
  export default {
    name: 'checkboxDemo',
    props: ['value', 'options', 'level', 'index'],
    data() {
      return {
        childValue: []
      }
    },
    methods: {
      selectThis(val) {
        let exist = _.findIndex(this.childValue, (res) => {
          return res == val.id
        }) > -1
        if (!exist) {
          this.childValue.push(val.id)
        } else {
          _.remove(this.childValue, (res) => {
            return res == val.id
          })
        }
        if (val.child) {
          this.getSelect(val.child, exist)
          this.change(this.childValue)
        }
        if (this.level == 1) {
          this.change(this.childValue)
        }
        this.isAll(exist, this.index)
      },
      getSelect(arr, exist) {
        _(arr).forEach((item) => {
          if (exist) {
            _.remove(this.childValue, (res) => {
              return res == item.id
            })
          } else {
            this.childValue.push(item.id)
          }
          if (item.child) {
            this.getSelect(item.child, exist)
          }
        })
        this.childValue = Array.from(new Set(this.childValue))
      },
      change(value) {
        this.$emit('input', value)
      },
      isAll(exist, index) {
        this.$emit('isAll', exist, index)
      }
    },
    created() {
      this.childValue = this.value
    },
    watch: {
      'value'() {
        if (this.value != this.childValue) {
          this.childValue = this.value
        }
      }
    },
    components: {
      checkboxDemo
    }
  }
</script>


// WEBPACK FOOTER //
// checkboxDemo.vue?6a882a1f